/* Northex Form — theme script. No dependencies. */
(function () {
  'use strict';
  var NX = window.NX = window.NX || {};
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  var fmt;
  try { fmt = new Intl.NumberFormat(NX.locale === 'en' ? 'en-US' : 'tr-TR', { style: 'currency', currency: NX.currency || 'TRY', minimumFractionDigits: 0, maximumFractionDigits: 2 }); }
  catch (e) { fmt = { format: function (v) { return v.toFixed(2) + ' ' + (NX.currency || 'TRY'); } }; }
  NX.money = function (cents) { return fmt.format((cents || 0) / 100); };

  /* ---------- toast ---------- */
  var toastEl = $('#nxToast'), toastT;
  NX.toast = function (msg) {
    if (!toastEl) return;
    toastEl.textContent = msg; toastEl.hidden = true; void toastEl.offsetWidth; toastEl.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.hidden = true; }, 3000);
  };

  /* ---------- scroll: nav + background drift + hero ---------- */
  var nav = $('#nxNav'), bg = $('#nxBg');
  var hero = $('[data-nx-hero]'), pin = hero && $('[data-pin]', hero), film = hero && $('[data-film]', hero);
  var heroDraw = null, FRAMES = 0, shown = -1;

  if (film) (function initFilm() {
    var canvas = $('canvas', film), list = [], masks = [];
    // phones get 960-wide frames: smaller decodes and texture uploads keep scrolling smooth
    var SMALL = matchMedia('(max-width: 900px)').matches;
    function json(sel) { try { return JSON.parse($(sel, film).textContent); } catch (e) { return []; } }
    list = SMALL ? json('[data-frames-small]') : json('[data-frames]');
    if (!list.length) list = json('[data-frames]');
    masks = json('[data-masks]');
    FRAMES = list.length; if (!FRAMES) return;
    if (SMALL) { canvas.width = 960; canvas.height = 542; }
    var useMask = masks.length === FRAMES;

    // WebGL draws each frame with its own alpha mask: only backdrop connected to the frame edge is cleared,
    // so dark areas inside the product (the coffee in the cup) stay solid. A vignette fades the edges.
    var paint = (function () {
      var gl = canvas.getContext('webgl', { premultipliedAlpha: true, alpha: true, antialias: false, powerPreference: 'low-power' });
      if (!gl || !useMask) { var c2 = canvas.getContext('2d'); return function (im) { c2.drawImage(im, 0, 0, canvas.width, canvas.height); }; }
      function sh(t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); return o; }
      var pr = gl.createProgram();
      gl.attachShader(pr, sh(gl.VERTEX_SHADER, 'attribute vec2 p;varying vec2 uv;void main(){uv=p*.5+.5;uv.y=1.-uv.y;gl_Position=vec4(p,0.,1.);}'));
      gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, 'precision mediump float;varying vec2 uv;uniform sampler2D t;uniform sampler2D k;void main(){vec4 c=texture2D(t,uv);float a=texture2D(k,uv).r;vec2 d=(uv-.5)/vec2(.5,.6);a*=1.-smoothstep(.64,1.,length(d));gl_FragColor=vec4(c.rgb*a,a);}'));
      gl.linkProgram(pr); gl.useProgram(pr);
      gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(pr, 'p'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      function makeTex(unit) {
        var t = gl.createTexture(); gl.activeTexture(gl.TEXTURE0 + unit); gl.bindTexture(gl.TEXTURE_2D, t);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR); gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        return t;
      }
      var tFrame = makeTex(0), tMask = makeTex(1);
      gl.uniform1i(gl.getUniformLocation(pr, 't'), 0); gl.uniform1i(gl.getUniformLocation(pr, 'k'), 1);
      gl.viewport(0, 0, canvas.width, canvas.height);
      return function (im, mk) {
        gl.activeTexture(gl.TEXTURE0); gl.bindTexture(gl.TEXTURE_2D, tFrame);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, im);
        gl.activeTexture(gl.TEXTURE1); gl.bindTexture(gl.TEXTURE_2D, tMask);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.LUMINANCE, gl.LUMINANCE, gl.UNSIGNED_BYTE, mk);
        gl.clearColor(0, 0, 0, 0); gl.clear(gl.COLOR_BUFFER_BIT); gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      };
    })();

    var frames = new Array(FRAMES);
    function ok(f) { return f && f.ok; }
    heroDraw = function (i) {
      var f = frames[i];
      if (!ok(f)) { for (var d = 1; d < FRAMES; d++) { if (ok(frames[i - d])) { f = frames[i - d]; break; } if (ok(frames[i + d])) { f = frames[i + d]; break; } } }
      if (!ok(f)) return;
      paint(f.img, f.mask); film.classList.add('live');
    };
    function loadImg(src) {
      return new Promise(function (res) {
        if (!src) return res(null);
        var im = new Image(); im.decoding = 'async';
        im.onload = function () {
          (im.decode ? im.decode() : Promise.resolve()).then(function () {
            // an ImageBitmap uploads to the GPU faster than an <img>, which matters on phones
            if (window.createImageBitmap) return createImageBitmap(im).then(res, function () { res(im); });
            res(im);
          }, function () { res(im); });
        };
        im.onerror = function () { res(null); };
        im.src = src;
      });
    }
    function loadFrame(idx) {
      var f = frames[idx] = { ok: false };
      return Promise.all([loadImg(list[idx]), useMask ? loadImg(masks[idx]) : Promise.resolve(true)]).then(function (r) {
        if (r[0] && r[1]) { f.img = r[0]; f.mask = r[1]; f.ok = true; }
      });
    }
    if (reduce) { loadFrame(0).then(function () { heroDraw(0); }); return; }
    var order = []; for (var s = 0; s < 4; s++) for (var i = s; i < FRAMES; i += 4) order.push(i);
    var next = 0, inflight = 0, MAXQ = SMALL ? 4 : 6;
    (function pump() {
      while (inflight < MAXQ && next < order.length) (function (idx) {
        inflight++;
        loadFrame(idx).then(function () { inflight--; if (Math.abs(idx - shown) < 4 || shown < 0) heroDraw(shown < 0 ? 0 : shown); pump(); });
      })(order[next++]);
    })();
  })();

  // The hero follows the scroll position through an eased value, so coarse touch scrolling
  // still plays the film and moves the wordmark smoothly instead of in jumps.
  var ticking = false, targetP = 0, curP = -1, easing = false, lastY = -1;
  function applyP(p) {
    pin.style.setProperty('--p', p.toFixed(4));
    if (heroDraw && !reduce) { var f = Math.round(p * (FRAMES - 1)); if (f !== shown) { shown = f; heroDraw(f); } }
  }
  function ease() {
    curP += (targetP - curP) * (reduce ? 1 : 0.22);
    if (Math.abs(targetP - curP) < 0.0008) curP = targetP;
    applyP(curP);
    if (curP !== targetP) requestAnimationFrame(ease); else easing = false;
  }
  function onScroll() {
    ticking = false;
    var y = window.scrollY;
    if (y !== lastY) {
      lastY = y;
      if (nav) nav.classList.toggle('solid', y > 30);
      if (bg) bg.style.setProperty('--sy', y.toFixed(0));
    }
    if (hero && pin) {
      var r = hero.getBoundingClientRect(), total = r.height - innerHeight;
      targetP = Math.min(1, Math.max(0, -r.top / (total || 1)));
      if (curP < 0) { curP = targetP; applyP(curP); }
      else if (!easing && curP !== targetP) { easing = true; requestAnimationFrame(ease); }
    }
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  addEventListener('resize', onScroll);
  onScroll();
  if (heroDraw && reduce) heroDraw(0);

  /* ---------- hero pack picker + buy ---------- */
  if (hero) {
    var buy = $('[data-buy]', hero), buyLabel = buy && $('[data-buy-label]', buy);
    $$('.variants button', hero).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.variants button', hero).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        if (!buy) return;
        buy.dataset.variantId = b.dataset.variantId;
        if (buyLabel) buyLabel.textContent = b.dataset.label;
        var sold = b.hasAttribute('data-soldout');
        buy.disabled = sold; $('span', buy).textContent = sold ? 'Tükendi' : 'Satın al';
      });
    });
    if (buy) buy.addEventListener('click', function () { NX.cart.add(buy.dataset.variantId, 1, buy); });
  }

  /* ---------- before/after sliders ---------- */
  $$('[data-compare]').forEach(function (c) {
    var r = $('input[type=range]', c);
    if (r) r.addEventListener('input', function () { c.style.setProperty('--x', r.value + '%'); });
  });

  /* ---------- product page ---------- */
  $$('[data-pdp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.dataset.pdpThumb;
      $$('[data-pdp-img]').forEach(function (im) { im.hidden = im.dataset.pdpImg !== i; });
      $$('[data-pdp-thumb]').forEach(function (o) { o.setAttribute('aria-pressed', o === t ? 'true' : 'false'); });
    });
  });
  $$('[data-pdp-variant]').forEach(function (s) {
    s.addEventListener('change', function () {
      var o = s.options[s.selectedIndex], price = $('[data-pdp-price]');
      if (price && o) price.textContent = o.dataset.price;
    });
  });
  $$('[data-qty]').forEach(function (q) {
    var input = $('input', q);
    $('[data-qty-minus]', q).addEventListener('click', function () { input.value = Math.max(1, (+input.value || 1) - 1); });
    $('[data-qty-plus]', q).addEventListener('click', function () { input.value = Math.min(20, (+input.value || 1) + 1); });
  });

  /* ---------- cart drawer (Shopify AJAX cart) ---------- */
  var drawer = $('#nxDrawer'), scrim = $('[data-cart-scrim]'), lastFocus = null, CODE_KEY = 'nx-code';
  function storeCode(v) { try { v ? localStorage.setItem(CODE_KEY, v) : localStorage.removeItem(CODE_KEY); } catch (e) {} }
  function readCode() { try { return localStorage.getItem(CODE_KEY) || ''; } catch (e) { return ''; } }

  function request(url, body) {
    return fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: body ? { 'Content-Type': 'application/json', 'Accept': 'application/json' } : { 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'error'); e.data = j; throw e; } return j; });
    });
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function render(cart) {
    if (!drawer) return;
    var list = $('[data-cart-items]', drawer), empty = !cart.item_count;
    drawer.classList.toggle('empty', empty);
    $('[data-cart-empty]', drawer).hidden = !empty;
    list.replaceChildren();
    cart.items.forEach(function (it) {
      var li = el('li', 'd-item');
      var im = el('img'); im.alt = ''; im.width = 72; im.height = 72; im.loading = 'lazy';
      if (it.image) im.src = it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200';
      var nm = el('div', 'nm'), a = el('a', null, it.product_title); a.href = it.url;
      var st = el('strong'); st.append(a); nm.append(st);
      if (it.variant_title && !it.product_has_only_default_variant) nm.append(el('span', null, it.variant_title));
      (it.line_level_discount_allocations || []).forEach(function (d) { nm.append(el('span', 'gift-tag', (d.discount_application && d.discount_application.title || 'İndirim') + ' · −' + NX.money(d.amount))); });
      var rt = el('div', 'rt'), stp = el('div', 'stepper');
      var minus = el('button', null, '−'); minus.type = 'button'; minus.setAttribute('aria-label', it.product_title + ' adedini azalt');
      var out = el('output', null, String(it.quantity));
      var plus = el('button', null, '+'); plus.type = 'button'; plus.setAttribute('aria-label', it.product_title + ' adedini artır');
      minus.addEventListener('click', function () { change(it.key, it.quantity - 1); });
      plus.addEventListener('click', function () { change(it.key, Math.min(20, it.quantity + 1)); });
      stp.append(minus, out, plus);
      var rm = el('button', 'd-rm', 'Kaldır'); rm.type = 'button'; rm.addEventListener('click', function () { change(it.key, 0); });
      rt.append(el('span', 'pr', NX.money(it.final_line_price)), stp, rm);
      li.append(im, nm, rt); list.append(li);
    });
    var disc = (cart.original_total_price || cart.total_price) - cart.total_price;
    $('[data-cart-sub]', drawer).textContent = NX.money(cart.original_total_price || cart.items_subtotal_price || cart.total_price);
    $('[data-cart-disc-row]', drawer).hidden = !(disc > 0);
    $('[data-cart-disc]', drawer).textContent = '−' + NX.money(disc);
    $('[data-cart-total]', drawer).textContent = NX.money(cart.total_price);
    var left = (NX.freeShipping || 0) - cart.total_price;
    $('[data-cart-hint]', drawer).textContent = cart.item_count && NX.freeShipping && left > 0 ? 'Ücretsiz kargo için ' + NX.money(left) + ' daha ekle.' : (cart.item_count && NX.freeShipping ? 'Kargo ücretsiz.' : '');
    var code = readCode(), co = $('[data-cart-checkout]', drawer);
    co.href = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
    $$('[data-cart-count]').forEach(function (b) { b.textContent = cart.item_count ? String(cart.item_count) : ''; });
    var btn = $('#nxCartBtn'); if (btn) btn.setAttribute('aria-label', 'Sepet, ' + cart.item_count + ' ürün');
  }
  function refresh() { return request(NX.routes.cart).then(function (c) { render(c); return c; }); }
  function change(key, qty) { return request(NX.routes.cartChange, { id: key, quantity: qty }).then(render).catch(function () { NX.toast('Sepet güncellenemedi, tekrar dene'); }); }
  function open() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.removeAttribute('inert'); drawer.setAttribute('aria-hidden', 'false');
    scrim.hidden = false; requestAnimationFrame(function () { drawer.classList.add('open'); });
    setTimeout(function () { var c = $('[data-cart-close]', drawer); if (c) c.focus(); }, 60);
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim.hidden = true;
    drawer.setAttribute('aria-hidden', 'true'); drawer.setAttribute('inert', '');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  NX.cart = {
    add: function (variantId, qty, trigger) {
      if (trigger) trigger.disabled = true;
      return request(NX.routes.cartAdd, { items: [{ id: +variantId, quantity: qty || 1 }] })
        .then(refresh).then(open)
        .catch(function (e) { NX.toast((e.data && e.data.description) || 'Ürün sepete eklenemedi'); })
        .then(function () { if (trigger) trigger.disabled = false; });
    },
    open: open, close: close, refresh: refresh
  };

  if (drawer) {
    $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); refresh().then(open, open); }); });
    $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    scrim.addEventListener('click', close);
    addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('open')) close(); });

    var codeIn = $('[data-cart-code]', drawer), codeMsg = $('[data-cart-code-msg]', drawer);
    codeIn.value = readCode();
    $('[data-cart-apply]', drawer).addEventListener('click', function () {
      var v = codeIn.value.trim().toUpperCase();
      storeCode(v);
      if (!v) { codeMsg.textContent = ''; return refresh(); }
      codeMsg.className = 'd-code-msg'; codeMsg.textContent = 'Kod kontrol ediliyor…';
      request(NX.routes.root.replace(/\/?$/, '/') + 'cart/update.js', { discount: v })
        .then(function (c) {
          render(c);
          var applied = (c.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === v && d.applicable; });
          codeMsg.className = 'd-code-msg ' + (applied ? 'ok' : '');
          codeMsg.textContent = applied ? 'Kod uygulandı.' : 'Kod ödeme adımında kontrol edilip uygulanacak.';
        })
        .catch(function () { codeMsg.className = 'd-code-msg'; codeMsg.textContent = 'Kod ödeme adımında kontrol edilip uygulanacak.'; refresh(); });
    });
    codeIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); $('[data-cart-apply]', drawer).click(); } });
    refresh().catch(function () {});
  }

  // phone bottom bar: pick a pack, add it from anywhere on the page
  var mbar = $('[data-mbar]');
  if (mbar) {
    var mbtns = $$('.mbar-packs button', mbar), mbuy = $('[data-mbar-buy]', mbar);
    var pick = mbtns.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; })[0] || mbtns[0];
    mbtns.forEach(function (b) {
      b.addEventListener('click', function () {
        pick = b;
        mbtns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      });
    });
    if (mbuy) mbuy.addEventListener('click', function () { if (pick && NX.cart) NX.cart.add(pick.dataset.variantId, 1, mbuy); });
  }

  // any add-to-cart form on the page goes through the drawer
  $$('form[data-nx-add]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      if (!NX.cart || !drawer) return;
      e.preventDefault();
      var id = f.querySelector('[name=id]').value, q = f.querySelector('[name=quantity]');
      NX.cart.add(id, q ? Math.max(1, +q.value || 1) : 1, f.querySelector('[type=submit]'));
    });
  });
})();
